export default class FinancePreselect {
    constructor(parent) {
        this.parent = parent;
        this.finance = parent.finance;
    }
    
    preselect() {
        this.finance.fromUrl();
    }
}